import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular";

if (environment.production) {
  enableProdMode();
}

const isBrokerPortal = typeof window !== 'undefined' && window.location.origin.includes('broker');

const portalType = isBrokerPortal ? "Broker Business Portal" : "EmployerOnlineTool"

const dsn = portalType === "Broker Business Portal" 
? "https://82d6910444cd85f1a41299154b38afca@o4508802250506240.ingest.us.sentry.io/4510341570625536" 
: "https://9e76ecc809c5bff17ef37632f26aa745@o4508802250506240.ingest.us.sentry.io/4510403816521728"

Sentry.init({
  dsn,

  environment: environment.envName,

  initialScope: {
    tags: {
      "portal": portalType
    }
  },

  sendDefaultPii: true,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  tracesSampleRate: environment.production ? 0.1 : 1, 

  tracePropagationTargets: [
    "localhost",
    /^https:\/\/employerapi(dev|tst)?\.nebraskablue\.com\/api/,
  ],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,

  enableLogs: true,
})

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

window.dataLayer = window.dataLayer || [];
 
declare global {
  interface Window {
    dataLayer: any[];
    gTagPush: (click_location: string, click_action: string) => void;
  }
}

window.gTagPush = function (click_location: string, click_action: string) {
  window.dataLayer.push({'event': 'broker_click', 'click_location': click_location, 'click_action': click_action})
};